import { Component, HostListener, ViewChild, OnInit, ElementRef, AfterViewInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ErrorService } from 'services/error.service';
import { ProspectService } from 'services/prospect.service';
import { SplashService } from 'services/splash.service';
import { EventEmitterService } from 'services/event-emitter.service';
import { Property } from '../../models/property';
import { VerifastIFrameResponse } from 'app/interface/verifastIframeResponse';
import { ProspectConfirm } from 'app/models/prospect-confirm';
import { VerifastStatus } from 'app/interface/verifastStatus';

@Component({
  selector: 'app-verifast',
  templateUrl: './verifast.component.html',
  styleUrls: ['./verifast.component.css']
})
export class VerifastApplicationComponent implements OnInit {
  isLoading: boolean;
  failedResult: boolean = false;
  iFrameURL = null;
  sessionComplete: boolean = false;
  hasRentableItems: boolean;
  totalApplicationSteps: number = 9;
  splashHTML: string;
  modelProperty: Property;
  isIdentityVerified: boolean = false;
  isIncomeVerified: boolean = false;
  showIframe: boolean = false;
  additionalApplicantKey: number;
  model: ProspectConfirm = new ProspectConfirm();
  showConfirmOcr: boolean;
  ocrConfirmed: boolean;
  continueEnabled: boolean = false;
  firstNameEmpty: boolean;
  middleNameEmpty: boolean;
  lastNameEmpty: boolean;
  addressEmpty: boolean;
  cityEmpty: boolean;
  stateEmpty: boolean;
  zipEmpty: boolean;
  licenseNumberEmpty: boolean;
  licenseExpirationEmpty: boolean;
  dateOfBirthEmpty: boolean;

  constructor(
    private prospectService: ProspectService, 
    public router: Router, 
    private errorService: ErrorService, 
    private splashService: SplashService, 
    private sanitizer: DomSanitizer,
    private eventEmitterService: EventEmitterService,
    ) {
    
    let AddAdditionalApplicantKey = localStorage.getItem('AddAdditionalApplicantKey');
    if (AddAdditionalApplicantKey !== null && AddAdditionalApplicantKey !== undefined) {
      this.additionalApplicantKey = Number(AddAdditionalApplicantKey);
    }

    this.getInitialVerificationStatuses();
    localStorage.setItem("ApplicationWorkflow", "true");
    this.eventEmitterService.splashChangeEmitted$.subscribe(res => this.updateSplashHTML(res));
    this.splashService.updateSplash("apply");
  }
  
  getInitialVerificationStatuses = () => {
    this.isLoading = true;

    if (this.additionalApplicantKey !== null) {
      this.prospectService.GetVerifastStatus(false, this.additionalApplicantKey).subscribe(res => this.onGetVerifastStatusIdentity(res), err => this.errorService.showError("Error getting verifast status."));
      this.prospectService.GetVerifastStatus(true, this.additionalApplicantKey).subscribe(res => this.onGetVerifastStatusIncome(res), err => this.errorService.showError("Error getting verifast status."));
    }
    else {
      this.prospectService.GetVerifastStatus(false, null).subscribe(res => this.onGetVerifastStatusIdentity(res), err => this.errorService.showError("Error getting verifast status."));
      this.prospectService.GetVerifastStatus(true, null).subscribe(res => this.onGetVerifastStatusIncome(res), err => this.errorService.showError("Error getting verifast status."));
    }
  }

  onGetVerifastStatusIdentity(res: VerifastStatus) {
    this.isIdentityVerified = res.IsVerified;
    this.ocrConfirmed = res.ConfirmedOcr;
    this.isLoading = false;
  }
  
  onGetVerifastStatusIncome(res: VerifastStatus) {
    this.isIncomeVerified = res.IsVerified;
    this.isLoading = false;
    if (this.isIncomeVerified) {
      this.continueEnabled = true;
    }
  }
  
  getVerifastUrl = (income: boolean) => {
    this.isLoading = true;
    if (income) {
      localStorage.setItem("isIncomeSession", "true");
    }

    // user has completed verifast iframe but not accepted OCR data yet
    if (this.isIdentityVerified === true && !this.ocrConfirmed) {
      if(this.additionalApplicantKey !== null) {
        // For "complete myself" workflow
        this.prospectService.GetSelfTourConfirmInfo(this.additionalApplicantKey).subscribe(res => this.onGetSelfTourConfirmInfo(res), res => this.errorService.showError(res));
      } else {
        this.prospectService.GetSelfTourConfirmInfo(null).subscribe(res => this.onGetSelfTourConfirmInfo(res), res => this.errorService.showError(res));
      }
    } else {
      if (this.additionalApplicantKey !== null) {
        this.prospectService.GetVerifastURL(income, this.additionalApplicantKey, "Application").subscribe(res => this.proccesVerifastURL(res, income), err => this.errorService.showError("Error initiating Verifast."));
      } else {
        this.prospectService.GetVerifastURL(income, null, "Application").subscribe(res => this.proccesVerifastURL(res, income), err => this.errorService.showError("Error initiating Verifast."));
      }
    }
  }
  
  ngOnInit() {
    const rentableItems = localStorage.getItem('hasRentableItems');
    const hasAncillaryItems = localStorage.getItem('HasAncillaryItems');
    if ((rentableItems && rentableItems === 'true') || (hasAncillaryItems && hasAncillaryItems === 'true')) {
      this.hasRentableItems = true;
      this.totalApplicationSteps++;
    }

    const property = JSON.parse(localStorage.getItem('SelectedProperty'));
    if (property != null) {
      this.modelProperty = property[0];
      if ((property[0].min_rent != null && property[0].max_rent != null) && (property[0].min_rent == property[0].max_rent)) {
        this.modelProperty.rent = property[0].min_rent.toLocaleString();
      }
      else if (property[0].min_rent != null && property[0].max_rent != null) {
        this.modelProperty.rent = property[0].min_rent.toLocaleString() + '-$' + property[0].max_rent.toLocaleString()
      }
    }
  }

  updateSplashHTML(res: string) {
    this.splashHTML = res;
  }

  proccesVerifastURL = (res: VerifastIFrameResponse, income: boolean) => {
    if (res.IFrameUrl) {
      this.iFrameURL = this.sanitizer.bypassSecurityTrustResourceUrl(res.IFrameUrl);
      localStorage.setItem("verifastSessionId", res.SessionId);
      this.isLoading = false;
      this.showIframe = true;
      if (income) {
        this.continueEnabled = true;
      }
    }
    else {
      this.errorService.showError("Error initiating Verifast.");
      this.isLoading = false;
    }
  }

  onGetSelfTourConfirmInfo(info: ProspectConfirm) {
    this.model = info;
  
    if (this.model.DateOfBirth !== null && this.model.DateOfBirth !== undefined) {
      this.model.DateOfBirth = this.prospectService.convertToLocalJSDate(this.model.DateOfBirth);
    }

    if (this.model.LicenseExpiration !== null && this.model.LicenseExpiration !== undefined) {
      this.model.LicenseExpiration = this.prospectService.convertToLocalJSDate(this.model.LicenseExpiration);
    }

    // To allow OCR fields to be editable if they come back empty -
    // A null check on the readonly field in the HTML works but as soon as 
    // a character is typed in it is no longer null and becomes readonly again. 
    if (!this.model.FirstName) {
      this.firstNameEmpty = true;
    }
    if (!this.model.MiddleName) {
      this.middleNameEmpty = true;
    }
    if (!this.model.LastName) {
      this.lastNameEmpty = true;
    }
    if (!this.model.Address) {
      this.addressEmpty = true;
    }
    if (!this.model.LicenseExpiration) {
      this.licenseExpirationEmpty = true;
    }
    if (!this.model.DateOfBirth) {
      this.dateOfBirthEmpty = true;
    }
    if (!this.model.LicenseNumber) {
      this.licenseNumberEmpty = true;
    }
    if (!this.model.Zip) {
      this.zipEmpty = true;
    }
    if (!this.model.City) {
      this.cityEmpty = true;
    }    
    if (!this.model.State) {
      this.stateEmpty = true;
    }

    this.isLoading = false;
    this.showConfirmOcr = true;
  }

  setIsLoading = (loading: boolean) => {
    this.isLoading = loading;
  }

  setShowIframe = (show: boolean) => {
    this.showIframe = show;
  }

  setVerificationResult = (income: boolean) => {
    this.showIframe = false;
    if(income) {
      this.isIncomeVerified = true;
      localStorage.removeItem("isIncomeSession");
    } else {
      // call to backend to get OCR data 
      this.isIdentityVerified = true;
      if(this.additionalApplicantKey !== null) {
        // For "complete myself" workflow
        this.prospectService.GetSelfTourConfirmInfo(this.additionalApplicantKey).subscribe(res => this.onGetSelfTourConfirmInfo(res), res => this.errorService.showError(res));
      } else {
        this.prospectService.GetSelfTourConfirmInfo(null).subscribe(res => this.onGetSelfTourConfirmInfo(res), res => this.errorService.showError(res));
      }
    }
  }

  setfailedResult = (loading: boolean) => {
    this.failedResult = loading;
  }

  deny() {
    this.isIdentityVerified = false;
    this.ocrConfirmed = false;
    this.showConfirmOcr = false;
    this.isLoading = true;
    if(this.additionalApplicantKey !== null) {
      this.prospectService.DenyOcrData(this.additionalApplicantKey).subscribe(res => this.onDeny(res), res => this.errorService.showError(res));
    } else {
      this.prospectService.DenyOcrData(null).subscribe(res => this.onDeny(res), res => this.errorService.showError(res));
    }
  }

  onDeny(res: boolean) {
    this.isLoading = false;
  }

  accept() {
    this.isIdentityVerified = true;

    var expiration = this.prospectService.convertToUTC(this.model.LicenseExpiration);
    var dob = this.prospectService.convertToUTC(this.model.DateOfBirth);
    const copyConfirmModel = {
      ...this.model,
      DateOfBirth : dob,
      LicenseExpiration : expiration
    };
    
    if(this.additionalApplicantKey !== null) {
      this.prospectService.UpdateSelfTourConfirmInfo(copyConfirmModel, this.additionalApplicantKey, true).subscribe(res => this.onUpdateInfo(res), res => this.errorService.showError(res));
    } else {
      this.prospectService.UpdateSelfTourConfirmInfo(copyConfirmModel, null, true).subscribe(res => this.onUpdateInfo(res), res => this.errorService.showError(res));
    }
  }
  
  onUpdateInfo(res: boolean){
    this.ocrConfirmed = true;
    this.showConfirmOcr = false;
  }

  continue() {
    if (!this.isIdentityVerified || !this.ocrConfirmed) {
      this.errorService.showError("Please Validate ID"); 
    } else {
      this.router.navigate(['/application/documents']);
    }
  }
}
